import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { describeAlert } from '../alerts/alertRegistry';

/**
 * The alerts for this screen, in one request to the server, which sends only the ones this person's role is meant to see; the wording
 * and buttons are in alerts/alertRegistry.js. Put one at the top of a module page with its module name and open section. `section` and
 * `reloadKey` ask again (for example when the person moves to another tab). Nothing shows when there is nothing to warn about.
 */
function ModuleAlerts({ module, section, reloadKey }) {
  const { user } = useAuth();
  const [found, setFound] = useState({ currency: null, alerts: [] });

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    axios.get('/api/alerts', { params: { module } })
      .then((r) => { if (!cancelled) setFound({ currency: r.data?.currency || null, alerts: Array.isArray(r.data?.alerts) ? r.data.alerts : [] }); })
      .catch(() => { if (!cancelled) setFound({ currency: null, alerts: [] }); });
    return () => { cancelled = true; };
  }, [user, module, section, reloadKey]);

  const fmt = (amount) => `${found.currency ? `${found.currency} ` : ''}${Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const shown = found.alerts.map((a) => describeAlert(a, user, module, section, fmt)).filter(Boolean);

  return shown.map((a) => (
    <Card key={a.key} className={`mb-4 border-${a.tone}`}>
      <Card.Body className="d-flex flex-wrap align-items-center gap-2 py-2">
        <i className={`bi ${a.icon} text-${a.tone}`} />
        <strong>{a.title}</strong>
        {a.detail && <span className="text-muted">{a.detail}</span>}
        {a.action && <Link to={a.action.to} className="btn btn-sm btn-outline-primary ms-auto">{a.action.label}</Link>}
      </Card.Body>
    </Card>
  ));
}

export default ModuleAlerts;
